import DTConfirmation from '../DTConfirmationView/DTConfirmation';

const SendMacroAndContinue = () => {
  return <DTConfirmation showDummyButton={true} withEdge={true} />;
};

export default SendMacroAndContinue;
